import { Inbox } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
} from "~/atoms/empty";

interface Props {
  message?: string;
  className?: string;
}

const NoResult = ({ message, className }: Props) => {
  const { t } = useTranslation();

  return (
    <Empty className={className}>
      <EmptyHeader>
        <EmptyMedia>
          <Inbox className="text-muted-foreground h-10 w-10" />
        </EmptyMedia>
        <EmptyDescription>
          {message ?? t(($) => $.commons.nothing)}
        </EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
};

export default NoResult;
